import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageShow from '../components/ImageShow';
import clsx from 'clsx';
import { env } from '../constants/env-config';
// import Chart from "chart.js/auto";
// import { Line } from "react-chartjs-2";

function Home() {
  const { t } = useTranslation();
  // const data = {
  //   labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  //   datasets: [
  //     {
  //       label: 'Freedom Broker',
  //       data: [33, 53, 85, 41, 44, 65],
  //       fill: true,
  //       backgroundColor: 'rgba(147,180,191,0.2)',
  //       borderColor: '#1A677B',
  //       tension: 0.5,
  //       pointStyle: 'circle',
  //       pointRadius: 6,
  //       pointHoverRadius: 10,
  //     },
  //     {
  //       label: 'InteractiveBrokers',
  //       data: [33, 25, 35, 51, 54, 76],
  //       fill: false,
  //       borderColor: '#742774',
  //       tension: 0.5,
  //       pointStyle: 'circle',
  //       pointRadius: 6,
  //       pointHoverRadius: 10,
  //     },
  //   ],
  // };
  return (
    <div className="page mt-[-16px] xl:mt-0 text-white relative bg-gradient-to-r from-cyan-650 to-cyan-75 z-[0]">
      <h1 className="text-2xl xl:pb-14 xl:pb-8 sm:pb-4 xs:text-lg xs:pb-5 xs:mt-2 xs:font-normal">{t('home.title')}</h1>
      <h2 className="text-[32px] xl:pb-8 xl:pb-4 sm:pb-2 xs:text-sm xs:pb-5 xs:font-light">
        {t('home.welcome')}
      </h2>
      <div className='flex flex-col w-full xl:gap-2 overflow-hidden xl:flex-row sm:gap-1 xs:gap-2.5'>
        <div className='flex-1 min-w-[40%] flex flex-wrap gap-2 flex-row xs:flex-col xs:gap-2.5'>
          <div className="p-7 flex flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 flex-1 min-w-[40%]">
            <h3 className="text-[18px] text-cyan-650 mb-8 xs:mb-6">{t('home.sections.accounts.title')}</h3>
            <p className="text-sm text-gray-350">
              {t('home.sections.accounts.description')}
            </p>
          </div>
          <div className="p-7 flex flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 flex-1 min-w-[40%]">
            <h3 className="text-[18px] text-cyan-650 mb-8 xs:mb-6">{t('home.sections.taxReports.title')}</h3>
            <p className="text-sm text-gray-350">
              {t('home.sections.taxReports.description')}
            </p>
          </div>
          <div className="p-7 flex flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 flex-1 min-w-[40%]">
            <h3 className="text-[18px] text-cyan-650 mb-8 xs:mb-6">{t('home.sections.taxFriends.title')}</h3>
            <p className="text-sm text-gray-350">
              {t('home.sections.taxFriends.description')}
            </p>
          </div>
          <div 
            className={
              clsx(
                "p-7 flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 flex-1 min-w-[40%]",
                env.ENABLE_OSA_WIKI !== "true" && "invisible"
              )
            }
          >
            <div className="flex justify-between">
              <h3 className="text-[18px] text-cyan-650 mb-8 xs:mb-6">{t('home.sections.wiki.title')}</h3>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://osa-tax.notion.site/WIKI-731de380af7e415d91bf9b6bd89c33b5?pvs=4"
                className="-mt-[5px] flex justify-center items-center w-[110px] h-[36px] mb-5 border-transparent rounded-xl text-white bg-gradient-to-r from-cyan-650 to-cyan-75 hover:from-cyan-900 hover:to-cyan-650">
                {t('open')}
              </a>
            </div>
            <p className="text-sm text-gray-350">
              {t('home.sections.wiki.description')}
            </p>
          </div>
        </div>
        <div className='flex-1'>
          <div className="flex-col rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50 flex-1 flex h-[45vh] max-h-[45vh]">
            <div className="flex justify-between p-7 pb-0">
              <h3 className="text-[18px] text-cyan-650 mb-4">{t('home.sections.video.title')}</h3>
            </div>
            <div className='rounded-[30px] w-full overflow-hidden flex-1'>
              <iframe
                width="100%"
                height="100%"
                src={env.MAIN_PAGE_VIDEO_URL}
                title="Як підготувати декларацію на платформі"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
      <p className="text-[16px] xl:mt-12 sm:mt-6 xs:mt-12 xs:font-normal">{t('home.otherServices')}</p>

      <div className="flex flex-col xl:gap-7 sm:gap-4 xs:gap-2.5">
          <div className="flex text-[14px] mt-4 flex-1 xl:gap-16 sm:gap-4 sm:flex-col xl:flex-row xs:mt-8 xs:gap-2.5 xs:flex-col">
              <div className='flex-[3] min-w-[200px] flex flex-col gap-2 xs:gap-2.5'>
                  <div className="font-medium text-[18px] ">
                      {t('home.services.calculation.title')}
                  </div>
              </div>
              <div className="flex-[5]">
                  {t('home.services.calculation.description')}
                  <br /><br />
                  {t('home.services.calculation.payment')}
                  <br /><br />
                  {t('home.services.calculation.note')}
              </div>
              <div className="font-medium  flex-[2] text-[18px]  mr-14">
                  {t('home.services.calculation.price')}
              </div>
          </div>

          <div className="flex flex-1 border-b border-white" />

          <div className="flex text-[14px] mt-4 flex-1 xl:gap-16 sm:gap-4 sm:flex-col xl:flex-row xs:mt-8 xs:gap-2.5 xs:flex-col">
              <div className='flex-[3] min-w-[200px] flex flex-col gap-2 xs:gap-2.5'>
                  <div className="font-medium text-[18px] ">
                      {t('home.services.calculationWithProfessional.title')}
                  </div>
              </div>
              <div className="flex-[5]">
                  {t('home.services.calculationWithProfessional.description')}
                  <br /><br />
                  {t('home.services.calculationWithProfessional.payment')}
                  <br /><br />
                  {t('home.services.calculationWithProfessional.note')}
              </div>
              <div className="font-medium  flex-[2] text-[18px]  mr-14">
                  {t('home.services.calculationWithProfessional.price')}
              </div>
          </div>

          <div className="flex flex-1 border-b border-white" />

        <div className="flex text-[14px] mt-4 flex-1 xl:gap-16 sm:gap-4 sm:flex-col xl:flex-row xs:mt-8 xs:gap-2.5 xs:flex-col">
          <div className='flex-[3] min-w-[200px] flex flex-col gap-2 xs:gap-2.5'>
            <div className="font-medium text-[18px]">
              {t('home.services.consultation.title')}
            </div>
            <span>
              {t('home.services.consultation.format')}
            </span>
          </div>
          <div className="flex-[5]">
            {t('home.services.consultation.description')}
          </div>
          <div className="font-medium  flex-[2] text-[18px] mr-14">
            {t('home.services.consultation.price')}
          </div>
        </div>

        <div className="flex flex-1 border-b border-white" />

        <div className="flex text-[14px] mt-4 flex-1 xl:gap-16 sm:gap-4 sm:flex-col xl:flex-row xs:mt-8 xs:gap-2.5 xs:flex-col">
          <div className='flex-[3] min-w-[200px] flex flex-col gap-2 xs:gap-2.5'>
            <div className="font-medium text-[18px] ">
              {t('home.services.submission.title')}
            </div>
          </div>
          <div className="flex-[5]">
            {t('home.services.submission.description')}
          </div>
          <div className="font-medium  flex-[2] text-[18px] mr-14">
            {t('home.services.submission.price')}
          </div>
        </div>

        <div className="flex flex-1 border-b border-white" />

        <div className="flex text-[14px] mt-4 flex-1 xl:gap-16 sm:gap-4 sm:flex-col xl:flex-row xs:mt-8 xs:gap-2.5 xs:flex-col">
          <div className='flex-[3] min-w-[200px] flex flex-col gap-2 xs:gap-2.5'>
            <div className="font-medium text-[18px] ">
              {t('home.services.taxResponse.title')}
            </div>
          </div>
          <div className="flex-[5]">
            {t('home.services.taxResponse.description')}
          </div>
          <div className="font-medium  flex-[2] text-[18px]  mr-14">
            {t('home.services.taxResponse.price')}
          </div>
        </div>

        <div className="flex flex-1 border-b border-white" />

        <a
          target="_blank"
          rel="noreferrer"
          href={window._env_?.GOOGLE_FORM_URL || "https://docs.google.com/forms/d/e/1FAIpQLSdWWXZ5yrrOmiCal3QLFrdO3x_enfTwTL_cNXx41LRf9S64sw/viewform"}
          className="flex text-[14px] mt-4 text-cyan-650 justify-center items-center w-[202px] h-[36px] mb-5 border-transparent rounded-xl bg-white hover:bg-cyan-650 hover:text-white hover:border-white hover:border  xs:mb-14">
          {t('home.useServices')}
        </a>

        <div className='flex justify-between gap-2 mb-12 md:mb-4 items-end mt-[-32px] xs:items-center'>
          <p className="text-[14px] flex sm:flex-col lgdef:flex-row lgdef:gap-5 gap-2 lgdef:mt-0 mt-4 xs:flex-col sx:gap-2.5 xs:mt-0">
            <span className="block md:inline-block xs:mb-3 xs:text-sm">
              {t('home.contacts.support')}
            </span>
            <a className="xs:text-base" href="mailto:client.service@osa.tax">
              <ImageShow image={{ url: 'envelope', label: 'envelope' }} />
              client.service@osa.tax
            </a>
            {
              env.LANGUAGE === "ua" && (
                <a className="xs:text-base" target="_blank" href="https://t.me/OSAtax" rel="noreferrer">
                  <ImageShow image={{ url: 'paperPlane', label: 'paperPlane' }} />
                  @OSAtax
                </a>
              )
            }
          </p>

          <div 
            className={
              clsx(
                'flex justify-end gap-2 cursor-pointer xs:flex-col-reverse xs:justify-center xs:items-center xs:gap-0',
                env.ENABLE_OSA_WIKI !== "true" && "invisible pointer-events-none"
              )
            }
            onClick={() => {
              window.open('https://osa-tax.notion.site/WIKI-731de380af7e415d91bf9b6bd89c33b5?pvs=4', '_blank');
            }}
          >
            <span className='text-white text-base flex flex-col items-end text-end xs:text-center xs:items-center'>
              {t('home.wikiSection.title')}
              <span className='text-xs'>
                {t('home.wikiSection.subtitle')}
              </span>
            </span>
            <div className='bg-white rounded-full text-[#93B4BF] w-14 h-14 justify-center items-center flex xs:w-12 xs:h-12'>
              ?
            </div>
          </div>
        </div>
      </div>

      {/* <div className="p-4 mt-2 w-full h-[400px] rounded-[30px] bg-gradient-to-r from-gray-250 to-gray-50">
        <Line
          data={data}
          width={"100%"}
          options={{ maintainAspectRatio: false }}
        />
      </div> */}
    </div>
  );
}

export default Home;
